export const API_ROOT_URL = 'https://mattroinho.vtv.vn/api';
export const API_BASE_URL = `${API_ROOT_URL}/v1`;

export function buildApiUrl(baseUrl: string, path: string, params?: Record<string, string | number | boolean | undefined>) {
  const query = Object.entries(params ?? {})
    .filter(([, value]) => value !== undefined)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
    .join('&');

  return `${baseUrl}${path}${query ? `?${query}` : ''}`;
}
